import { render, staticRenderFns } from "./ModalTarget.vue?vue&type=template&id=13bfe43a&"
import script from "./ModalTarget.vue?vue&type=script&lang=js&"
export * from "./ModalTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports